export enum NotificationCardTypes {
    VIDEO = "video",
    PDF = "pdf",
    ADMIN_MESSAGE = "admin_message",
    TUTOR_REPLY = "tutor",
    EXERCISE = "excercise",
    EXAM_EXERCISE = "exam_exercise",
    CHAPTER_CONTENT = "chaptor_content",
    EXAM_CHAPTER_CONTENT = "exam_chapter_content"
}